
function checkState(resolver, payload) {
    if ((document.readyState === "interactive") || (document.readyState === "complete")) {
        resolver(payload);
        return true;
    }

    return false;
}

function documentReady(payload) {
    return new Promise((resolve) => {
        if (!checkState(resolve, payload)) {
            document.addEventListener("DOMContentLoaded", () => {
                checkState(resolve, payload);
            });
        } else {
            resolve();
        }
    });
}

export default documentReady;